import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Import pages from the pages folder
import Home from './pages/Home';
import Configvol from './pages/Configvol';
import Selectchannels from './pages/Selectchannels';
import Setup from './pages/Setup';
import FindRemote from './pages/FindRemote';
import { BluetoothProvider } from './BluetoothContext';

function App() {
  return (
    <BluetoothProvider>
      <Router>
        <div className="App">
          <Header />
          <main className="App-main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/setup" element={<Setup />} />
              <Route path="/configvol" element={<Configvol />} />
              <Route path="/selectchannels" element={<Selectchannels />} />
              <Route path="/find-remote" element={<FindRemote />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </BluetoothProvider>

  );
}

export default App;
